import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Link } from 'react-router-dom';
import { HelpCircle, ArrowRight } from 'lucide-react';

const FAQHomeSection = () => {
  const { language } = useLanguage();

  const topQuestions = {
    en: [
      {
        q: "How do I request a quote?",
        a: "Call us at 469-434-8287, email info@palerminsurance.com, or use our online forms. We serve in English and Spanish."
      },
      {
        q: "When does my coverage start?",
        a: "Coverage starts only after policy issuance is confirmed and the effective date is established by the carrier."
      },
      {
        q: "How do I make a payment?",
        a: "Use your insurance carrier's official payment portal. Contact your agent for the correct payment link."
      },
      {
        q: "How do I report a claim?",
        a: "For emergencies, call 911. Then report directly to your carrier and contact us for guidance."
      }
    ],
    es: [
      {
        q: "¿Cómo solicito una cotización?",
        a: "Llámenos al 469-434-8287, envíe correo a info@palerminsurance.com, o use nuestros formularios en línea. Atendemos en inglés y español."
      },
      {
        q: "¿Cuándo comienza mi cobertura?",
        a: "La cobertura comienza solo después de confirmar la emisión de la póliza y establecer la fecha efectiva por la aseguradora."
      },
      {
        q: "¿Cómo hago un pago?",
        a: "Use el portal oficial de pagos de su aseguradora. Contacte a su agente para el enlace correcto de pago."
      },
      {
        q: "¿Cómo reporto una reclamación?",
        a: "Para emergencias, llame al 911. Luego reporte directamente a su aseguradora y contáctenos para orientación."
      }
    ]
  };

  const content = {
    en: {
      title: "Frequently Asked Questions",
      subtitle: "Quick answers to common questions",
      viewAll: "View All FAQs",
      notFound: "Need more help? Contact us at 469-434-8287"
    },
    es: {
      title: "Preguntas Frecuentes",
      subtitle: "Respuestas rápidas a preguntas comunes",
      viewAll: "Ver Todas las Preguntas",
      notFound: "¿Necesita más ayuda? Contáctenos al 469-434-8287"
    }
  };

  const text = content[language];
  const questions = topQuestions[language];

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-block bg-blue-100 p-4 rounded-full mb-4">
            <HelpCircle className="w-8 h-8 text-blue-700" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {text.title}
          </h2>
          <p className="text-xl text-gray-600">
            {text.subtitle}
          </p>
        </div>

        {/* FAQ Grid */}
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-6 mb-12">
          {questions.map((item, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-shadow border border-gray-100"
            >
              <h3 className="font-bold text-lg text-gray-900 mb-3">
                {item.q}
              </h3>
              <p className="text-gray-700 text-sm leading-relaxed">
                {item.a}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/faq"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-8 py-4 rounded-full text-lg font-semibold shadow-lg hover:shadow-xl transition-all hover:-translate-y-1"
          >
            {text.viewAll}
            <ArrowRight className="w-5 h-5" />
          </Link>
          
          <p className="text-gray-600 text-sm mt-6">
            {text.notFound}
          </p>
        </div>
      </div>
    </section>
  );
};

export default FAQHomeSection;
